import { Component, inject } from '@angular/core';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { SplashScreenService } from './core/services/splash-screen.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: 'app.component.html',
})
export class AppComponent {
  title = 'Bacart-CPL-FrontEnd';
  private _router = inject(Router);
  private _splashScreenService = inject(SplashScreenService);
  constructor() {
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationError) {
        this._splashScreenService.hide();
      }
    });
  }
}
